export default "__VITE_ASSET__CMW9_9Sp__"